import { createSelector } from '@ngrx/store';

import { surveyFeature } from '../survey.feature';

const { selectSupplier } = surveyFeature;

export const selectSupplierAllocations = createSelector(
  selectSupplier,
  ({ allocations }) => allocations,
);

export const selectSupplierAllocationsLoading = createSelector(
  selectSupplier,
  ({ allocationsLoading }) => allocationsLoading,
);

export const selectSupplierAllocationsError = createSelector(
  selectSupplier,
  ({ allocationsError }) => allocationsError,
);

export const selectSupplierAllocationsUpdateStatus = createSelector(
  selectSupplier,
  ({ allocationsUpdateStatus }) => allocationsUpdateStatus,
);

export const selectSupplierAllocationsUpdating = createSelector(
  selectSupplierAllocationsUpdateStatus,
  (status) => status === 'saving',
);

export const selectSupplierBlends = createSelector(
  selectSupplier,
  ({ blends }) => blends,
);

export const selectSupplierBlendsLoading = createSelector(
  selectSupplier,
  ({ blendsLoading }) => blendsLoading,
);

export const selectSupplierBlendsError = createSelector(
  selectSupplier,
  ({ blendsError }) => blendsError,
);

export const selectSupplierFlexibilityPriceParams = createSelector(
  selectSupplier,
  ({ flexibilityPriceParams }) => flexibilityPriceParams,
);

export const selectSupplierFlexibilityPriceParamsLoading = createSelector(
  selectSupplier,
  ({ flexibilityPriceParamsLoading }) => flexibilityPriceParamsLoading,
);

export const selectSupplierFlexibilityPriceParamsError = createSelector(
  selectSupplier,
  ({ flexibilityPriceParamsError }) => flexibilityPriceParamsError,
);
